import { MacrosData } from "@/types/elements";
import { configStore, uiStore } from "@/store/store-accessor";
import {
  compileTwigTemplate,
  getAllTwigMacrosString,
  TWIG_MACROS_CACHE_KEY
} from "@/lib/twig/twig";

export function setTwigMacrosInStoreAndRecompile(twigMacros: MacrosData) {
  configStore.setTwigMacros(twigMacros);

  // The local storage hash and cache will be updated on page refresh
  // Don't touch it here
  compileTwigTemplate(
    getAllTwigMacrosString(twigMacros),
    TWIG_MACROS_CACHE_KEY
  );

  // force the Canvas to re-render everything, since macros are not reactive
  uiStore.forceUpdateEntireCanvas();
}
